export default __webpack_public_path__ + "78c70bbb07859e5af9d6f1ae865edba3.png";